import { render, staticRenderFns } from "./DuoJiSalesChangeLeader.vue?vue&type=template&id=bda1d9ea&scoped=true"
import script from "./DuoJiSalesChangeLeader.vue?vue&type=script&lang=js"
export * from "./DuoJiSalesChangeLeader.vue?vue&type=script&lang=js"
import style0 from "./DuoJiSalesChangeLeader.vue?vue&type=style&index=0&id=bda1d9ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bda1d9ea",
  null
  
)

export default component.exports